import withStore from 'store/StoreContainer';
import {
  // actions
  updatePreferences,
  resetDraft,
  resetSection,
  // routes
  goToDraftView,
  goToEditDraft,
  // selectors
  draftStateSelector,
  resetStateSelector,
  resetSectionStateSelector,
  isSavingSelector,
  isPendingSaveSelector,
  draftIdSelector,
  draftNameSelector,
  draftStatusSelector,
} from 'modules/v2/editor/store';

const mapStateToProps = (state) => ({
  draft: draftStateSelector(state),
  draftName: draftNameSelector(state),
  draftStatus: draftStatusSelector(state),
  draftId: draftIdSelector(state),
  reset: resetStateSelector(state),
  resetSection: resetSectionStateSelector(state),
  isSaving: isSavingSelector(state),
  isPendingSave: isPendingSaveSelector(state),
});

const mapDispatchToProps = {
  resetDraft,
  resetCurrentSection: resetSection,
  updatePreferences,
  goToDraftView,
  goToEditDraft,
};

export default withStore(mapStateToProps, mapDispatchToProps);
